const $eeb8a1757523bd58$var$MAIN_PRESETS = [
    "classic",
    "chime",
    "arcade"
];
const $eeb8a1757523bd58$var$MICRO_PRESETS = [
    "classic",
    "chime",
    "arcade"
];
const $eeb8a1757523bd58$export$318776eb124dba96 = {
    minDepth: 4,
    maxDepth: 12,
    heightTarget: 0.95,
    forceFlipAfterSteps: 10,
    initialDepth: 6,
    clickTargetDepthOptions: [
        5,
        6,
        7,
        8
    ],
    targetDepthNudgeChoices: [
        -1,
        1
    ],
    randomBoolThreshold: 0.5,
    targetDepthRandomNudgeChance: 0.12,
    mutateBoolPathChance: 0.55,
    evolveMutateChance: 0.6,
    evolveGrowChance: 0.8,
    forceFlipAttempts: 24,
    forceFlipMutateChance: 0.7,
    forceFlipGrowChance: 0.85
};
const $eeb8a1757523bd58$export$739e76c578cb9e96 = {
    minFontSize: 14,
    fitFontMinPx: 1,
    fitFontTolerancePx: 0.5,
    fontSizeRecoveryBuffer: 1,
    constrainMaxShrinkSteps: 8
};
const $eeb8a1757523bd58$export$364f2e897df4bd43 = {
    stepMs: 110,
    stepMsMin: 55,
    stepMsMax: 240,
    stepMsDriftPerStep: 10,
    stepMsReturnRate: 0.08,
    burstChance: 0.08,
    burstMultiplier: 0.5,
    burstLengthMin: 6,
    burstLengthMax: 18,
    lullChance: 0.05,
    lullMultiplier: 1.6,
    lullLengthMin: 8,
    lullLengthMax: 20
};
const $eeb8a1757523bd58$export$77e0afa2f61c53ee = {
    enabled: true,
    masterGain: 0.05,
    attackS: 0.005,
    releaseS: 0.14,
    trueStartHz: 640,
    trueEndHz: 960,
    trueDurationS: 0.11,
    falseStartHz: 300,
    falseEndHz: 120,
    falseDurationS: 0.16,
    detuneCents: 9,
    microDurationS: 0.045,
    microGainMultiplier: 0.45,
    microTrueHz: 760,
    microFalseHz: 220,
    microVarianceHz: 26,
    microDetuneCents: 3,
    mainPresets: $eeb8a1757523bd58$var$MAIN_PRESETS,
    mainPreset: "arcade",
    microPresets: $eeb8a1757523bd58$var$MICRO_PRESETS,
    microPreset: "arcade"
};
const $eeb8a1757523bd58$export$c85ba824665b708f = {
    idleMs: 1800
};
const $eeb8a1757523bd58$export$9803a9beefbb6be1 = $eeb8a1757523bd58$export$318776eb124dba96.minDepth;
const $eeb8a1757523bd58$export$1fa8ce0cc2ea267e = $eeb8a1757523bd58$export$318776eb124dba96.maxDepth;
const $eeb8a1757523bd58$export$be34544934ee4c55 = $eeb8a1757523bd58$export$318776eb124dba96.heightTarget;
const $eeb8a1757523bd58$export$a4d6e528a3062818 = $eeb8a1757523bd58$export$318776eb124dba96.forceFlipAfterSteps;
const $eeb8a1757523bd58$export$ddff916431abe07f = $eeb8a1757523bd58$export$318776eb124dba96.initialDepth;
const $eeb8a1757523bd58$export$a399e933611502b = $eeb8a1757523bd58$export$318776eb124dba96.clickTargetDepthOptions;
const $eeb8a1757523bd58$export$61b3fa1a95b10c42 = $eeb8a1757523bd58$export$318776eb124dba96.targetDepthNudgeChoices;
const $eeb8a1757523bd58$export$36356b6d3757dd6e = $eeb8a1757523bd58$export$318776eb124dba96.randomBoolThreshold;
const $eeb8a1757523bd58$export$f89ced69e25ca888 = $eeb8a1757523bd58$export$318776eb124dba96.targetDepthRandomNudgeChance;
const $eeb8a1757523bd58$export$6a3d91da4e060b25 = $eeb8a1757523bd58$export$318776eb124dba96.mutateBoolPathChance;
const $eeb8a1757523bd58$export$93ad2bbd2cc621fb = $eeb8a1757523bd58$export$318776eb124dba96.evolveMutateChance;
const $eeb8a1757523bd58$export$d7e98c42c5bff128 = $eeb8a1757523bd58$export$318776eb124dba96.evolveGrowChance;
const $eeb8a1757523bd58$export$bc0d750ba3bdc833 = $eeb8a1757523bd58$export$318776eb124dba96.forceFlipAttempts;
const $eeb8a1757523bd58$export$ddb8d6ccfc849d3a = $eeb8a1757523bd58$export$318776eb124dba96.forceFlipMutateChance;
const $eeb8a1757523bd58$export$5d46248ede586412 = $eeb8a1757523bd58$export$318776eb124dba96.forceFlipGrowChance;
const $eeb8a1757523bd58$export$51d8dda0950aa13f = $eeb8a1757523bd58$export$739e76c578cb9e96.minFontSize;
const $eeb8a1757523bd58$export$25370295dc82736e = $eeb8a1757523bd58$export$739e76c578cb9e96.fitFontMinPx;
const $eeb8a1757523bd58$export$96f670125380f540 = $eeb8a1757523bd58$export$739e76c578cb9e96.fitFontTolerancePx;
const $eeb8a1757523bd58$export$c00f76f7e3c6d8a0 = $eeb8a1757523bd58$export$739e76c578cb9e96.fontSizeRecoveryBuffer;
const $eeb8a1757523bd58$export$b38a52f865bcfe66 = $eeb8a1757523bd58$export$739e76c578cb9e96.constrainMaxShrinkSteps;
const $eeb8a1757523bd58$export$1c157dcc99d415d8 = $eeb8a1757523bd58$export$364f2e897df4bd43.stepMs;
const $eeb8a1757523bd58$export$e03f18b96579c159 = $eeb8a1757523bd58$export$364f2e897df4bd43.stepMsMin;
const $eeb8a1757523bd58$export$c96dd95c35a90337 = $eeb8a1757523bd58$export$364f2e897df4bd43.stepMsMax;
const $eeb8a1757523bd58$export$b2b415ed5cf79afa = $eeb8a1757523bd58$export$364f2e897df4bd43.stepMsDriftPerStep;
const $eeb8a1757523bd58$export$2774a5891b482436 = $eeb8a1757523bd58$export$364f2e897df4bd43.stepMsReturnRate;
const $eeb8a1757523bd58$export$b47a622fd9d55d7e = $eeb8a1757523bd58$export$364f2e897df4bd43.burstChance;
const $eeb8a1757523bd58$export$36f977eed08c61fb = $eeb8a1757523bd58$export$364f2e897df4bd43.burstMultiplier;
const $eeb8a1757523bd58$export$cc568d56245b070e = $eeb8a1757523bd58$export$364f2e897df4bd43.burstLengthMin;
const $eeb8a1757523bd58$export$456b1571bfa83da6 = $eeb8a1757523bd58$export$364f2e897df4bd43.burstLengthMax;
const $eeb8a1757523bd58$export$6d120df0316bfce3 = $eeb8a1757523bd58$export$364f2e897df4bd43.lullChance;
const $eeb8a1757523bd58$export$3079805d6785f315 = $eeb8a1757523bd58$export$364f2e897df4bd43.lullMultiplier;
const $eeb8a1757523bd58$export$461932ad1699a8ba = $eeb8a1757523bd58$export$364f2e897df4bd43.lullLengthMin;
const $eeb8a1757523bd58$export$8c31a644d25cf65 = $eeb8a1757523bd58$export$364f2e897df4bd43.lullLengthMax;
const $eeb8a1757523bd58$export$eaa4681349b8ce49 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.enabled;
const $eeb8a1757523bd58$export$7b8d2b13de398866 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.masterGain;
const $eeb8a1757523bd58$export$f86c15bd8a0abc47 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.attackS;
const $eeb8a1757523bd58$export$eae24b5e70d46255 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.releaseS;
const $eeb8a1757523bd58$export$93370327c161e7af = $eeb8a1757523bd58$export$77e0afa2f61c53ee.trueStartHz;
const $eeb8a1757523bd58$export$33f0fba3db203611 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.trueEndHz;
const $eeb8a1757523bd58$export$823dfc509558160f = $eeb8a1757523bd58$export$77e0afa2f61c53ee.trueDurationS;
const $eeb8a1757523bd58$export$5d12615a65c541cf = $eeb8a1757523bd58$export$77e0afa2f61c53ee.falseStartHz;
const $eeb8a1757523bd58$export$f268158fe76af626 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.falseEndHz;
const $eeb8a1757523bd58$export$b531093806954c21 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.falseDurationS;
const $eeb8a1757523bd58$export$b9f4ef03c2350c9a = $eeb8a1757523bd58$export$77e0afa2f61c53ee.detuneCents;
const $eeb8a1757523bd58$export$f9ee0b7e1b8e78b4 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.microDurationS;
const $eeb8a1757523bd58$export$cf3749ac927b073 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.microGainMultiplier;
const $eeb8a1757523bd58$export$31929636b55e8f5 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.microTrueHz;
const $eeb8a1757523bd58$export$8c806cb120ed8310 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.microFalseHz;
const $eeb8a1757523bd58$export$e9dcbe9805779bd0 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.microVarianceHz;
const $eeb8a1757523bd58$export$b9a18c6858d2220 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.microDetuneCents;
const $eeb8a1757523bd58$export$553bfcb9fc89730d = $eeb8a1757523bd58$export$77e0afa2f61c53ee.mainPresets;
const $eeb8a1757523bd58$export$e69c33525e1cfe1a = $eeb8a1757523bd58$export$77e0afa2f61c53ee.mainPreset;
const $eeb8a1757523bd58$export$e30f43174e8720ac = $eeb8a1757523bd58$export$77e0afa2f61c53ee.microPresets;
const $eeb8a1757523bd58$export$2e0810524378d8c7 = $eeb8a1757523bd58$export$77e0afa2f61c53ee.microPreset;
const $eeb8a1757523bd58$export$ddd25885b60634ec = $eeb8a1757523bd58$export$c85ba824665b708f.idleMs;


const $621296994be36c78$export$b1ebdddbecfe1d88 = ()=>{
    let audioContext = null;
    let enabled = false;
    const getAudioContext = ()=>{
        if (!audioContext) audioContext = new AudioContext();
        return audioContext;
    };
    const unlock = ()=>{
        if (!(0, $eeb8a1757523bd58$export$eaa4681349b8ce49)) return;
        const ctx = getAudioContext();
        if (ctx.state === "suspended") ctx.resume();
    };
    const setEnabled = (next)=>{
        enabled = next;
        if (enabled) unlock();
    };
    const getState = ()=>({
            supported: (0, $eeb8a1757523bd58$export$eaa4681349b8ce49),
            enabled: enabled,
            running: audioContext?.state === "running"
        });
    const playSweep = (startHz, endHz, durationS, type, detuneCents = 0, gainScale = 1)=>{
        if (!(0, $eeb8a1757523bd58$export$eaa4681349b8ce49) || !enabled) return;
        const ctx = getAudioContext();
        if (ctx.state !== "running") return;
        const now = ctx.currentTime;
        const gain = ctx.createGain();
        const osc = ctx.createOscillator();
        gain.gain.setValueAtTime(0, now);
        gain.gain.linearRampToValueAtTime((0, $eeb8a1757523bd58$export$7b8d2b13de398866) * gainScale, now + (0, $eeb8a1757523bd58$export$f86c15bd8a0abc47));
        gain.gain.linearRampToValueAtTime(0, now + durationS + (0, $eeb8a1757523bd58$export$eae24b5e70d46255));
        osc.type = type;
        osc.frequency.setValueAtTime(startHz, now);
        osc.frequency.exponentialRampToValueAtTime(endHz, now + durationS);
        osc.detune.setValueAtTime(detuneCents, now);
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start(now);
        osc.stop(now + durationS + (0, $eeb8a1757523bd58$export$eae24b5e70d46255));
    };
    const mainPresetPlayers = {
        classic: (isTrue)=>{
            if (isTrue) {
                playSweep((0, $eeb8a1757523bd58$export$93370327c161e7af), (0, $eeb8a1757523bd58$export$33f0fba3db203611), (0, $eeb8a1757523bd58$export$823dfc509558160f), "triangle", (0, $eeb8a1757523bd58$export$b9f4ef03c2350c9a));
                playSweep((0, $eeb8a1757523bd58$export$93370327c161e7af) * 1.5, (0, $eeb8a1757523bd58$export$33f0fba3db203611) * 1.5, (0, $eeb8a1757523bd58$export$823dfc509558160f), "sine");
                return;
            }
            playSweep((0, $eeb8a1757523bd58$export$5d12615a65c541cf), (0, $eeb8a1757523bd58$export$f268158fe76af626), (0, $eeb8a1757523bd58$export$b531093806954c21), "sawtooth", -(0, $eeb8a1757523bd58$export$b9f4ef03c2350c9a));
            playSweep((0, $eeb8a1757523bd58$export$5d12615a65c541cf) * 1.33, (0, $eeb8a1757523bd58$export$f268158fe76af626) * 1.2, (0, $eeb8a1757523bd58$export$b531093806954c21), "square");
        },
        chime: (isTrue)=>{
            if (isTrue) {
                playSweep(660, 990, 0.085, "sine", 0, 0.9);
                playSweep(825, 1320, 0.11, "triangle", 0, 0.65);
                return;
            }
            playSweep(390, 246, 0.16, "triangle", -6, 0.9);
            playSweep(292, 146, 0.17, "sine", -10, 0.6);
        },
        arcade: (isTrue)=>{
            if (isTrue) {
                playSweep(740, 880, 0.06, "square", 5, 0.95);
                playSweep(880, 1320, 0.075, "square", 2, 0.7);
                return;
            }
            playSweep(260, 170, 0.09, "square", -5, 0.95);
            playSweep(170, 95, 0.11, "sawtooth", -12, 0.75);
        }
    };
    const playTransition = (isTrue)=>{
        mainPresetPlayers[0, $eeb8a1757523bd58$export$e69c33525e1cfe1a](isTrue);
    };
    const microPresetPlayers = {
        classic: (isTrue)=>{
            const baseHz = isTrue ? (0, $eeb8a1757523bd58$export$31929636b55e8f5) : (0, $eeb8a1757523bd58$export$8c806cb120ed8310);
            const variance = (Math.random() * 2 - 1) * (0, $eeb8a1757523bd58$export$e9dcbe9805779bd0);
            const startHz = Math.max(40, baseHz + variance);
            const endHz = Math.max(40, startHz * (isTrue ? 1.02 : 0.98));
            playSweep(startHz, endHz, (0, $eeb8a1757523bd58$export$f9ee0b7e1b8e78b4), "sine", isTrue ? (0, $eeb8a1757523bd58$export$b9a18c6858d2220) : -(0, $eeb8a1757523bd58$export$b9a18c6858d2220), (0, $eeb8a1757523bd58$export$cf3749ac927b073));
        },
        chime: (isTrue)=>{
            const baseHz = isTrue ? (0, $eeb8a1757523bd58$export$31929636b55e8f5) : (0, $eeb8a1757523bd58$export$8c806cb120ed8310);
            const variance = (Math.random() * 2 - 1) * (0, $eeb8a1757523bd58$export$e9dcbe9805779bd0);
            const startHz = Math.max(40, baseHz + variance * 0.8);
            const endHz = Math.max(40, startHz * (isTrue ? 1.05 : 0.95));
            playSweep(startHz, endHz, (0, $eeb8a1757523bd58$export$f9ee0b7e1b8e78b4) * 1.15, "triangle", isTrue ? (0, $eeb8a1757523bd58$export$b9a18c6858d2220) : -(0, $eeb8a1757523bd58$export$b9a18c6858d2220), (0, $eeb8a1757523bd58$export$cf3749ac927b073) * 0.95);
        },
        arcade: (isTrue)=>{
            const baseHz = isTrue ? (0, $eeb8a1757523bd58$export$31929636b55e8f5) : (0, $eeb8a1757523bd58$export$8c806cb120ed8310);
            const variance = (Math.random() * 2 - 1) * (0, $eeb8a1757523bd58$export$e9dcbe9805779bd0);
            const startHz = Math.max(40, baseHz + variance * 1.2);
            const endHz = Math.max(40, startHz * (isTrue ? 1.01 : 0.93));
            playSweep(startHz, endHz, (0, $eeb8a1757523bd58$export$f9ee0b7e1b8e78b4) * 0.9, "square", isTrue ? (0, $eeb8a1757523bd58$export$b9a18c6858d2220) : -(0, $eeb8a1757523bd58$export$b9a18c6858d2220), (0, $eeb8a1757523bd58$export$cf3749ac927b073) * 1.1);
        }
    };
    const playMicro = (isTrue)=>{
        microPresetPlayers[0, $eeb8a1757523bd58$export$2e0810524378d8c7](isTrue);
    };
    return {
        unlock: unlock,
        setEnabled: setEnabled,
        getState: getState,
        playTransition: playTransition,
        playMicro: playMicro
    };
};




const $e7b8fffc52052cba$export$36b22efa6d0cd639 = {
    and: {
        symbol: "\u2227",
        f: (a, b)=>a && b
    },
    or: {
        symbol: "\u2228",
        f: (a, b)=>a || b
    },
    xor: {
        symbol: "\u2295",
        f: (a, b)=>a !== b
    },
    imply: {
        symbol: "\u2192",
        f: (a, b)=>!a || b
    },
    converse: {
        symbol: "\u2190",
        f: (a, b)=>a || !b
    },
    xnor: {
        symbol: "\u2261",
        f: (a, b)=>a === b
    },
    nand: {
        symbol: "\u2191",
        f: (a, b)=>!(a && b)
    },
    nor: {
        symbol: "\u2193",
        f: (a, b)=>!(a || b)
    },
    nimply: {
        symbol: "\u219B",
        f: (a, b)=>a && !b
    }
};
class $e7b8fffc52052cba$export$227dc6ea969f5b51 {
    constructor(operator){
        this.operator = operator;
    }
    f(...args) {
        return $e7b8fffc52052cba$export$36b22efa6d0cd639[this.operator].f.apply(null, args);
    }
    toString() {
        return $e7b8fffc52052cba$export$36b22efa6d0cd639[this.operator].symbol;
    }
}
class $e7b8fffc52052cba$export$6e6298e1abe0d5b {
    constructor(value, negate = false){
        this.negate = negate;
        this._value = value;
        this.value = negate ? !value : value;
    }
    toString() {
        return `${this.negate ? "\xac" : ""}${this._value}`;
    }
}
class $e7b8fffc52052cba$export$c84356afd4299847 {
    constructor(p, operator, q){
        this.p = p;
        this.operator = new $e7b8fffc52052cba$export$227dc6ea969f5b51(operator);
        this.q = q;
        this.value = this.operator.f(p.value, q.value);
    }
    toString() {
        return `(${this.p} ${this.operator} ${this.q})`;
    }
}



const $c21940f1d722f508$export$4812e460280c6ef2 = (xs)=>xs[Math.floor(Math.random() * xs.length)];
const $c21940f1d722f508$export$3c5f89dae98e900b = (min, max)=>Math.floor(Math.random() * (max - min + 1)) + min;
const $c21940f1d722f508$export$8a83211c878a3f1f = (threshold = 0.5)=>Math.random() > threshold;
const $c21940f1d722f508$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(max, value));


const $95f3aaae635352d9$var$operators = Object.keys((0, $e7b8fffc52052cba$export$36b22efa6d0cd639));
const $95f3aaae635352d9$var$sampleOperator = ()=>(0, $c21940f1d722f508$export$4812e460280c6ef2)($95f3aaae635352d9$var$operators);
const $95f3aaae635352d9$var$statement = ()=>new (0, $e7b8fffc52052cba$export$c84356afd4299847)(new (0, $e7b8fffc52052cba$export$6e6298e1abe0d5b)((0, $c21940f1d722f508$export$8a83211c878a3f1f)((0, $eeb8a1757523bd58$export$36356b6d3757dd6e)), (0, $c21940f1d722f508$export$8a83211c878a3f1f)((0, $eeb8a1757523bd58$export$36356b6d3757dd6e))), $95f3aaae635352d9$var$sampleOperator(), new (0, $e7b8fffc52052cba$export$6e6298e1abe0d5b)((0, $c21940f1d722f508$export$8a83211c878a3f1f)((0, $eeb8a1757523bd58$export$36356b6d3757dd6e)), (0, $c21940f1d722f508$export$8a83211c878a3f1f)((0, $eeb8a1757523bd58$export$36356b6d3757dd6e))));
const $95f3aaae635352d9$export$7a0b7889d47a3c0c = (depth)=>depth === 0 ? $95f3aaae635352d9$var$statement() : new (0, $e7b8fffc52052cba$export$c84356afd4299847)($95f3aaae635352d9$export$7a0b7889d47a3c0c(depth - 1), $95f3aaae635352d9$var$sampleOperator(), $95f3aaae635352d9$export$7a0b7889d47a3c0c(depth - 1));
const $95f3aaae635352d9$var$isStatement = (node)=>node instanceof (0, $e7b8fffc52052cba$export$c84356afd4299847);
const $95f3aaae635352d9$var$getOperator = (node)=>node.operator.operator;
const $95f3aaae635352d9$var$getNodeAt = (node, path)=>path.reduce((current, branch)=>{
        if (!$95f3aaae635352d9$var$isStatement(current)) return current;
        return branch === "p" ? current.p : current.q;
    }, node);
const $95f3aaae635352d9$var$replaceAt = (node, path, replace)=>{
    if (path.length === 0) return replace(node);
    if (!$95f3aaae635352d9$var$isStatement(node)) return node;
    const [branch, ...rest] = path;
    const child = branch === "p" ? node.p : node.q;
    const nextChild = $95f3aaae635352d9$var$replaceAt(child, rest, replace);
    const p = branch === "p" ? nextChild : node.p;
    const q = branch === "q" ? nextChild : node.q;
    return new (0, $e7b8fffc52052cba$export$c84356afd4299847)(p, $95f3aaae635352d9$var$getOperator(node), q);
};
const $95f3aaae635352d9$var$collectPaths = (node, path = [], acc = {
    bools: [],
    statements: []
})=>{
    if ($95f3aaae635352d9$var$isStatement(node)) {
        acc.statements.push(path);
        $95f3aaae635352d9$var$collectPaths(node.p, [
            ...path,
            "p"
        ], acc);
        $95f3aaae635352d9$var$collectPaths(node.q, [
            ...path,
            "q"
        ], acc);
    } else acc.bools.push(path);
    return acc;
};
const $95f3aaae635352d9$export$d63cd6ad70de44fa = (node)=>$95f3aaae635352d9$var$isStatement(node) ? 1 + Math.max($95f3aaae635352d9$export$d63cd6ad70de44fa(node.p), $95f3aaae635352d9$export$d63cd6ad70de44fa(node.q)) : 0;
const $95f3aaae635352d9$export$a56c334827fea2b7 = (root)=>{
    const paths = $95f3aaae635352d9$var$collectPaths(root).bools;
    if (!paths.length) return root;
    const path = (0, $c21940f1d722f508$export$4812e460280c6ef2)(paths);
    const leaf = $95f3aaae635352d9$var$getNodeAt(root, path);
    if (!(leaf instanceof (0, $e7b8fffc52052cba$export$6e6298e1abe0d5b))) return root;
    const seed = new (0, $e7b8fffc52052cba$export$6e6298e1abe0d5b)((0, $c21940f1d722f508$export$8a83211c878a3f1f)((0, $eeb8a1757523bd58$export$36356b6d3757dd6e)), (0, $c21940f1d722f508$export$8a83211c878a3f1f)((0, $eeb8a1757523bd58$export$36356b6d3757dd6e)));
    const branch = (0, $c21940f1d722f508$export$8a83211c878a3f1f)((0, $eeb8a1757523bd58$export$36356b6d3757dd6e)) ? new (0, $e7b8fffc52052cba$export$c84356afd4299847)(leaf, $95f3aaae635352d9$var$sampleOperator(), seed) : new (0, $e7b8fffc52052cba$export$c84356afd4299847)(seed, $95f3aaae635352d9$var$sampleOperator(), leaf);
    const next = $95f3aaae635352d9$var$replaceAt(root, path, ()=>branch);
    return $95f3aaae635352d9$var$isStatement(next) ? next : root;
};
const $95f3aaae635352d9$export$163bf020ddbc63f3 = (root)=>{
    const paths = $95f3aaae635352d9$var$collectPaths(root).statements.filter((path)=>path.length > 0);
    if (!paths.length) return root;
    const path = (0, $c21940f1d722f508$export$4812e460280c6ef2)(paths);
    const node = $95f3aaae635352d9$var$getNodeAt(root, path);
    if (!$95f3aaae635352d9$var$isStatement(node)) return root;
    const next = $95f3aaae635352d9$var$replaceAt(root, path, ()=>new (0, $e7b8fffc52052cba$export$6e6298e1abe0d5b)(node.value, false));
    return $95f3aaae635352d9$var$isStatement(next) ? next : root;
};
const $95f3aaae635352d9$export$5ac47b9bce194efc = (root)=>{
    const paths = $95f3aaae635352d9$var$collectPaths(root);
    if (Math.random() < (0, $eeb8a1757523bd58$export$6a3d91da4e060b25) && paths.bools.length) {
        const path = (0, $c21940f1d722f508$export$4812e460280c6ef2)(paths.bools);
        const node = $95f3aaae635352d9$var$getNodeAt(root, path);
        if (!(node instanceof (0, $e7b8fffc52052cba$export$6e6298e1abe0d5b))) return root;
        const mutated = (0, $c21940f1d722f508$export$8a83211c878a3f1f)((0, $eeb8a1757523bd58$export$36356b6d3757dd6e)) ? new (0, $e7b8fffc52052cba$export$6e6298e1abe0d5b)(node._value, !node.negate) : new (0, $e7b8fffc52052cba$export$6e6298e1abe0d5b)(!node._value, node.negate);
        const next = $95f3aaae635352d9$var$replaceAt(root, path, ()=>mutated);
        return $95f3aaae635352d9$var$isStatement(next) ? next : root;
    }
    const path = (0, $c21940f1d722f508$export$4812e460280c6ef2)(paths.statements);
    const node = $95f3aaae635352d9$var$getNodeAt(root, path);
    if (!$95f3aaae635352d9$var$isStatement(node)) return root;
    const next = $95f3aaae635352d9$var$replaceAt(root, path, ()=>new (0, $e7b8fffc52052cba$export$c84356afd4299847)(node.p, $95f3aaae635352d9$var$sampleOperator(), node.q));
    return $95f3aaae635352d9$var$isStatement(next) ? next : root;
};
const $95f3aaae635352d9$export$5ab8c077758e2bd2 = (root, targetDepth)=>{
    const depth = $95f3aaae635352d9$export$d63cd6ad70de44fa(root);
    if (depth < targetDepth) return $95f3aaae635352d9$export$a56c334827fea2b7(root);
    if (depth > targetDepth) return $95f3aaae635352d9$export$163bf020ddbc63f3(root);
    const r = Math.random();
    if (r < (0, $eeb8a1757523bd58$export$93ad2bbd2cc621fb)) return $95f3aaae635352d9$export$5ac47b9bce194efc(root);
    if (r < (0, $eeb8a1757523bd58$export$d7e98c42c5bff128)) return $95f3aaae635352d9$export$a56c334827fea2b7(root);
    return $95f3aaae635352d9$export$163bf020ddbc63f3(root);
};
const $95f3aaae635352d9$export$400e0f17b59eaa4d = (root)=>{
    const baseline = root.value;
    let candidate = root;
    for(let i = 0; i < (0, $eeb8a1757523bd58$export$bc0d750ba3bdc833); i += 1){
        const mode = Math.random();
        candidate = mode < (0, $eeb8a1757523bd58$export$ddb8d6ccfc849d3a) ? $95f3aaae635352d9$export$5ac47b9bce194efc(candidate) : mode < (0, $eeb8a1757523bd58$export$5d46248ede586412) ? $95f3aaae635352d9$export$a56c334827fea2b7(candidate) : $95f3aaae635352d9$export$163bf020ddbc63f3(candidate);
        if (candidate.value !== baseline) return candidate;
    }
    return candidate;
};



const $fb56d9b51a79131e$export$3f0b0800cb866b8e = ({ viewport: viewport, tempo: tempo, audio: audio })=>{
    const pauseStateKey = "__logicalConnectivesPaused";
    const getPaused = ()=>Boolean(globalThis[pauseStateKey]);
    const setPaused = (next)=>{
        globalThis[pauseStateKey] = next;
    };
    if (globalThis[pauseStateKey] === undefined) setPaused(false);
    let current = (0, $95f3aaae635352d9$export$7a0b7889d47a3c0c)((0, $eeb8a1757523bd58$export$ddff916431abe07f));
    let targetDepth = (0, $eeb8a1757523bd58$export$ddff916431abe07f);
    let lastStep = 0;
    let lastValue = current.value;
    let lastBackgroundValue = current.value;
    let lastStatementText = current.toString();
    let stepsSinceFlip = 0;
    let started = false;
    const renderConstrained = (state)=>{
        let next = state;
        let fontSize = viewport.render(next);
        let guard = 0;
        while(fontSize < (0, $eeb8a1757523bd58$export$51d8dda0950aa13f) && (0, $95f3aaae635352d9$export$d63cd6ad70de44fa)(next) > (0, $eeb8a1757523bd58$export$9803a9beefbb6be1) && guard < (0, $eeb8a1757523bd58$export$b38a52f865bcfe66)){
            next = (0, $95f3aaae635352d9$export$163bf020ddbc63f3)(next);
            fontSize = viewport.render(next);
            guard += 1;
        }
        return {
            next: next,
            fontSize: fontSize
        };
    };
    const nudgeTargetDepth = (fontSize)=>{
        const fill = viewport.getFill();
        const depth = (0, $95f3aaae635352d9$export$d63cd6ad70de44fa)(current);
        if (fill.height < (0, $eeb8a1757523bd58$export$be34544934ee4c55) && depth < (0, $eeb8a1757523bd58$export$1fa8ce0cc2ea267e)) targetDepth = Math.min((0, $eeb8a1757523bd58$export$1fa8ce0cc2ea267e), targetDepth + 1);
        if (fontSize < (0, $eeb8a1757523bd58$export$51d8dda0950aa13f) + (0, $eeb8a1757523bd58$export$c00f76f7e3c6d8a0) && depth > (0, $eeb8a1757523bd58$export$9803a9beefbb6be1)) targetDepth = Math.max((0, $eeb8a1757523bd58$export$9803a9beefbb6be1), targetDepth - 1);
        if (Math.random() < (0, $eeb8a1757523bd58$export$f89ced69e25ca888)) targetDepth = Math.max((0, $eeb8a1757523bd58$export$9803a9beefbb6be1), Math.min((0, $eeb8a1757523bd58$export$1fa8ce0cc2ea267e), targetDepth + (0, $c21940f1d722f508$export$4812e460280c6ef2)((0, $eeb8a1757523bd58$export$61b3fa1a95b10c42))));
    };
    const step = ()=>{
        current = (0, $95f3aaae635352d9$export$5ab8c077758e2bd2)(current, targetDepth);
        let frame = renderConstrained(current);
        current = frame.next;
        if (current.value === lastValue) stepsSinceFlip += 1;
        else {
            stepsSinceFlip = 0;
            lastValue = current.value;
        }
        if (stepsSinceFlip >= (0, $eeb8a1757523bd58$export$a4d6e528a3062818)) {
            frame = renderConstrained((0, $95f3aaae635352d9$export$400e0f17b59eaa4d)(current));
            current = frame.next;
            stepsSinceFlip = 0;
            lastValue = current.value;
        }
        const statementText = current.toString();
        const didFlip = current.value !== lastBackgroundValue;
        const didChangeStatement = statementText !== lastStatementText;
        if (didFlip) {
            audio.playTransition(current.value);
            lastBackgroundValue = current.value;
        } else if (didChangeStatement) audio.playMicro(current.value);
        lastStatementText = statementText;
        nudgeTargetDepth(frame.fontSize);
    };
    const animate = (timestamp)=>{
        if (!getPaused() && timestamp - lastStep >= tempo.interval()) {
            step();
            tempo.update();
            lastStep = timestamp;
        }
        requestAnimationFrame(animate);
    };
    const start = ()=>{
        if (started) return;
        started = true;
        current = renderConstrained(current).next;
        requestAnimationFrame(animate);
    };
    const click = ()=>{
        targetDepth = (0, $c21940f1d722f508$export$4812e460280c6ef2)((0, $eeb8a1757523bd58$export$a399e933611502b));
    };
    const resize = ()=>{
        current = renderConstrained(current).next;
    };
    const togglePause = ()=>{
        const next = !getPaused();
        setPaused(next);
        return next;
    };
    return {
        start: start,
        click: click,
        resize: resize,
        togglePause: togglePause
    };
};




const $c493655ee5378c71$export$93f39f42dcdfb7aa = ()=>{
    let stepIntervalMs = (0, $eeb8a1757523bd58$export$1c157dcc99d415d8);
    let burstStepsLeft = 0;
    let lullStepsLeft = 0;
    const interval = ()=>stepIntervalMs;
    const update = ()=>{
        if (burstStepsLeft > 0) {
            burstStepsLeft -= 1;
            stepIntervalMs = (0, $c21940f1d722f508$export$7d15b64cf5a3a4c4)((0, $eeb8a1757523bd58$export$1c157dcc99d415d8) * (0, $eeb8a1757523bd58$export$36f977eed08c61fb), (0, $eeb8a1757523bd58$export$e03f18b96579c159), (0, $eeb8a1757523bd58$export$c96dd95c35a90337));
            return;
        }
        if (lullStepsLeft > 0) {
            lullStepsLeft -= 1;
            stepIntervalMs = (0, $c21940f1d722f508$export$7d15b64cf5a3a4c4)((0, $eeb8a1757523bd58$export$1c157dcc99d415d8) * (0, $eeb8a1757523bd58$export$3079805d6785f315), (0, $eeb8a1757523bd58$export$e03f18b96579c159), (0, $eeb8a1757523bd58$export$c96dd95c35a90337));
            return;
        }
        if (Math.random() < (0, $eeb8a1757523bd58$export$b47a622fd9d55d7e)) {
            burstStepsLeft = (0, $c21940f1d722f508$export$3c5f89dae98e900b)((0, $eeb8a1757523bd58$export$cc568d56245b070e), (0, $eeb8a1757523bd58$export$456b1571bfa83da6));
            return;
        }
        if (Math.random() < (0, $eeb8a1757523bd58$export$6d120df0316bfce3)) {
            lullStepsLeft = (0, $c21940f1d722f508$export$3c5f89dae98e900b)((0, $eeb8a1757523bd58$export$461932ad1699a8ba), (0, $eeb8a1757523bd58$export$8c31a644d25cf65));
            return;
        }
        const drift = (Math.random() * 2 - 1) * (0, $eeb8a1757523bd58$export$b2b415ed5cf79afa);
        const relaxed = stepIntervalMs + ((0, $eeb8a1757523bd58$export$1c157dcc99d415d8) - stepIntervalMs) * (0, $eeb8a1757523bd58$export$2774a5891b482436);
        stepIntervalMs = (0, $c21940f1d722f508$export$7d15b64cf5a3a4c4)(relaxed + drift, (0, $eeb8a1757523bd58$export$e03f18b96579c159), (0, $eeb8a1757523bd58$export$c96dd95c35a90337));
    };
    return {
        interval: interval,
        update: update
    };
};


const $ebbf5b9152d571ec$export$d7ed1f2d38c9761e = ({ audio: audio, idleMs: idleMs })=>{
    const soundToggle = document.createElement("button");
    soundToggle.type = "button";
    soundToggle.className = "sound-toggle";
    document.body.appendChild(soundToggle);
    let idleTimer;
    const renderSoundToggle = ()=>{
        const state = audio.getState();
        soundToggle.textContent = state.enabled ? "\uD83D\uDD0A" : "\uD83D\uDD07";
        soundToggle.setAttribute("aria-label", state.enabled ? "Disable sound" : "Enable sound");
        soundToggle.dataset.state = state.enabled ? "on" : "off";
        soundToggle.disabled = !state.supported;
    };
    const clearIdleTimer = ()=>{
        if (!idleTimer) return;
        window.clearTimeout(idleTimer);
        idleTimer = undefined;
    };
    const scheduleIdle = ()=>{
        clearIdleTimer();
        if (!audio.getState().enabled) {
            document.body.classList.remove("idle-ui");
            return;
        }
        idleTimer = window.setTimeout(()=>{
            document.body.classList.add("idle-ui");
        }, idleMs);
    };
    const wake = ()=>{
        document.body.classList.remove("idle-ui");
        scheduleIdle();
    };
    soundToggle.addEventListener("click", (event)=>{
        event.stopPropagation();
        const state = audio.getState();
        audio.setEnabled(!state.enabled);
        wake();
        renderSoundToggle();
    });
    renderSoundToggle();
    const handleGlobalClick = ()=>{
        const state = audio.getState();
        if (!state.enabled) {
            audio.setEnabled(true);
            renderSoundToggle();
        }
        wake();
    };
    return {
        handleGlobalClick: handleGlobalClick,
        handleActivity: wake
    };
};



const $f1d08346c8b3406e$export$e553497b10624e79 = (root)=>{
    const getAvailableSpace = ()=>{
        const style = getComputedStyle(document.body);
        return {
            width: window.innerWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight),
            height: window.innerHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom)
        };
    };
    const getFill = ()=>{
        const bounds = root.getBoundingClientRect();
        const space = getAvailableSpace();
        return {
            width: bounds.width / space.width,
            height: bounds.height / space.height
        };
    };
    const fitToScreen = ()=>{
        let min = (0, $eeb8a1757523bd58$export$25370295dc82736e);
        let max = Math.min(window.innerWidth, window.innerHeight);
        while(max - min > (0, $eeb8a1757523bd58$export$96f670125380f540)){
            const mid = (min + max) / 2;
            document.body.style.fontSize = `${mid}px`;
            const bounds = root.getBoundingClientRect();
            const space = getAvailableSpace();
            if (bounds.width > space.width || bounds.height > space.height) max = mid;
            else min = mid;
        }
        document.body.style.fontSize = `${min}px`;
        return min;
    };
    const render = (state)=>{
        root.textContent = state.toString();
        const fontSize = fitToScreen();
        document.body.classList.remove("true", "false");
        document.body.classList.add(String(state.value));
        return fontSize;
    };
    return {
        getFill: getFill,
        render: render
    };
};


const $b4e14b6b8da86996$var$ROOT = document.getElementById("root");
if (!$b4e14b6b8da86996$var$ROOT) throw new Error("Root element not found");
const $b4e14b6b8da86996$var$viewport = (0, $f1d08346c8b3406e$export$e553497b10624e79)($b4e14b6b8da86996$var$ROOT);
const $b4e14b6b8da86996$var$audio = (0, $621296994be36c78$export$b1ebdddbecfe1d88)();
const $b4e14b6b8da86996$var$tempo = (0, $c493655ee5378c71$export$93f39f42dcdfb7aa)();
const $b4e14b6b8da86996$var$engine = (0, $fb56d9b51a79131e$export$3f0b0800cb866b8e)({
    viewport: $b4e14b6b8da86996$var$viewport,
    tempo: $b4e14b6b8da86996$var$tempo,
    audio: $b4e14b6b8da86996$var$audio
});
const $b4e14b6b8da86996$var$ui = (0, $ebbf5b9152d571ec$export$d7ed1f2d38c9761e)({
    audio: $b4e14b6b8da86996$var$audio,
    idleMs: (0, $eeb8a1757523bd58$export$ddd25885b60634ec)
});
document.body.classList.add("use-p3");
$b4e14b6b8da86996$var$engine.start();
document.addEventListener("click", ()=>{
    $b4e14b6b8da86996$var$ui.handleGlobalClick();
    $b4e14b6b8da86996$var$engine.click();
});
window.addEventListener("pointermove", $b4e14b6b8da86996$var$ui.handleActivity);
window.addEventListener("pointerdown", $b4e14b6b8da86996$var$ui.handleActivity);
document.addEventListener("keydown", (event)=>{
    $b4e14b6b8da86996$var$ui.handleActivity();
    if (event.repeat) return;
    if (event.code === "Space") {
        event.preventDefault();
        const paused = $b4e14b6b8da86996$var$engine.togglePause();
        document.body.classList.toggle("paused", paused);
    }
});
window.addEventListener("resize", ()=>{
    $b4e14b6b8da86996$var$engine.resize();
});
document.addEventListener("dblclick", ()=>{
    if (document.fullscreenElement) {
        document.exitFullscreen();
        return;
    }
    document.documentElement.requestFullscreen();
});


//# sourceMappingURL=repo.1e70e6b1.js.map
